export default "__VITE_ASSET__BWVieBk1__";